import { useCallback } from 'react';

import { CanvasServiceFactory } from '../services/Canvas/CanvasServiceFactory';

/**
 * Returns actions to control the canvas's camera
 */
export const useCanvasCamera = () => {
  const zoomFit = useCallback(() => {
    CanvasServiceFactory.getInstance().createCanvasService().zoomToFit();
  }, []);
  const zoomIn = useCallback(() => {
    CanvasServiceFactory.getInstance().createCanvasService().zoomIn();
  }, []);
  const zoomOut = useCallback(() => {
    CanvasServiceFactory.getInstance().createCanvasService().zoomOut();
  }, []);
  const zoomReset = useCallback(() => {
    CanvasServiceFactory.getInstance().createCanvasService().zoomTo(100);
  }, []);

  return { zoomFit, zoomOut, zoomIn, zoomReset };
};
